import { GenericDialogBox } from "../dialog/dialog-component"
import { AppSpinner } from "../spinner/spinner-component"
import React from "react"
import { isLargeScreen } from "../myhooks/custom-hooks"
import { ScrollArea } from "@/components/ui/scroll-area";

function AppSessionPage(props) {
    return (
        <>
            <div className="side_bar">
                <span className="m-3 inline-block h-fit w-min px-3 relative">
                    <div className="inline-block w-max font-sans text-xl/normal font-bold sm:text-3xl/loose">
                        {props.timeText}
                    </div>
                    <div className="inline-block w-max font-sans text-xs/snug font-normal sm:text-base/normal">
                        Total duration
                    </div>
                </span>



                {props.speakers && props.speakers.length !== 0 ? (
                    <div className="flex relative max-w-4/6 flex-1 flex-row items-stretch justify-start sm:w-min sm:flex-col sm:max-w-full 
                                border-2 border-blue-500 rounded-lg px-2 mt-8 before:content-[attr(data-label)] 
                    before:absolute before:-top-3 before:left-4  before:px-2 before:bg-white before:text-blue-500 before:font-semibold"
                        data-label="Participants">
                        <ScrollArea className="h-[200px] mt-5 pr-3 border border-red-500">
                            {props.speakers.map((part, index) => (

                                <button
                                    className="toolbar-button"
                                    onClick={part.action}
                                    key={index}
                                >{`${part.alias}`}</button>

                            ))
                            }
                        </ScrollArea>
                    </div>) :

                    (
                        <></>
                    )}

                {props.seesions && props.seesions.length !== 0 ? (
                    <div className="flex relative max-w-4/6 flex-1 flex-row items-stretch justify-start sm:w-min sm:flex-col sm:max-w-full 
                                border-2 border-blue-500 rounded-lg px-2 mt-8 before:content-[attr(data-label)] 
                    before:absolute before:-top-3 before:left-4  before:px-2 before:bg-white before:text-blue-500 before:font-semibold"
                        data-label="Sessions">
                        <ScrollArea className="h-[200px] mt-5 pr-3 border border-red-500">
                            {props.seesions.map((part, index) => (

                                <button
                                    className="toolbar-button"
                                    onClick={part.action}
                                    key={index}
                                >{`${part.title}`}</button>

                            ))
                            }
                        </ScrollArea>
                    </div>) :

                    (
                        <></>
                    )}


                <div className="flex relative max-w-4/6 flex-1 flex-row items-center justify-center sm:w-min sm:flex-col sm:max-w-full">
                    {props.menus && props.menus.length ? (
                        props.menus.map((menu, index) => (
                            <button
                                className="toolbar-button"
                                onClick={menu.action}
                                key={index}
                            >{`${menu.title}`}</button>
                        ))
                    ) : (
                        <></>
                    )}
                </div>

                <button
                    className="relative mx-2 box-border w-19 cursor-pointer rounded-4xl border bg-[#FF6363] px-1 py-2 text-center font-sans text-base/normal font-normal text-[#FAFAFC] transition-shadow hover:shadow-2xl disabled:hidden sm:w-33 sm:text-xl/loose sm:mx-0 sm:my-5"
                    onClick={props.onEndSession}
                    disabled={!props.session.recording || props.fromClient}
                >
                    End
                </button>
            </div>

            <GenericDialogBox show={props.sessionEnding}>
                <div className="block">
                    <div className="dialog-heading">
                        Session Ending...
                    </div>
                    <div className="text-center">
                        <AppSpinner></AppSpinner>
                    </div>
                </div>
            </GenericDialogBox>
        </>
    )
}

export { AppSessionPage }
